/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TextBulletChecklistIcon32Regular = forwardRef('TextBulletChecklistIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M12.207 4.707a1 1 0 0 0-1.414-1.414L6 8.086 4.207 6.293a1 1 0 0 0-1.414 1.414L4.586 9.5a2 2 0 0 0 2.828 0l4.793-4.793Z" }),
        React.createElement("path", { d: "M28 8H16a1 1 0 1 1 0-2h12a1 1 0 1 1 0 2Z" }),
        React.createElement("path", { d: "M16 15a1 1 0 1 0 0 2h12a1 1 0 1 0 0-2H16Z" }),
        React.createElement("path", { d: "M28 24H16a1 1 0 1 0 0 2h12a1 1 0 1 0 0-2Z" }),
        React.createElement("path", { d: "M12.207 12.293a1 1 0 0 1 0 1.414L7.414 18.5a2 2 0 0 1-2.828 0l-1.793-1.793a1 1 0 1 1 1.414-1.414L6 17.086l4.793-4.793a1 1 0 0 1 1.414 0Z" }),
        React.createElement("path", { d: "M12.207 22.707a1 1 0 0 0-1.414-1.414L6 26.086l-1.793-1.793a1 1 0 0 0-1.414 1.414L4.586 27.5a2 2 0 0 0 2.828 0l4.793-4.793Z" })));
});
